
import Component from 'vue-class-component'
import moduleStore from './store/magic';
import Vue from 'vue';
import PageState from './store/state';


/**components**/
@Component({})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class magicPage extends Vue implements IvuePage<PageState>{
	state = new PageState();
	self: Vue = this;
	// service?: service;
	// controller?: controller;
	created(moduleData: IinjectDatas) {
		document.title = "魔法小问学院"
		this.state = <PageState>moduleData.state;
	}
	async mounted(moduleData: IinjectDatas) {
		/*this.$http("getDataList",{}).then((response:any)=>{
			console.log(response)
		}).catch((ex:any)=>{
			console.log(ex)
		})*/

		this.state.title = "这是更改后的title"
		this.state.self = this;
		
		this.state.magicList = await this._getUserCourses(1, 10)
	}
	async onRefresh() {
		this.state.page = 1
		// 清空列表数据
		this.state.finished = false;
		// 重新加载数据
		// 将 loading 设置为 true，表示处于加载状态
		this.state.loading = true;
		const res: any = await this._getUserCourses(1, 10)
		this.state.magicList = res
		this.state.refreshing = false;
		this.state.loading = false;

		// this.onLoad();
	}
	//当组件滚动到底部时，会触发load事件
	async onLoad() {
		this.state.page+=1
		this.state.loading = true;
		this.state.finished = false;
		const res: any = await this._getUserCourses(this.state.page, 10)
		if(res){
			if (res.length > 0) {
				res.forEach(ele => {
					this.state.magicList.push(ele)
				});
				this.state.loading = false;
			} else {
				this.state.loading = false;
				this.state.finished = true;
				// this.state.page = 1
			}
		}else{
			this.state.loading = false;
			this.state.finished = true;
		}
	}
	_getUserCourses(page, pageSize) {
		return new Promise((resolve, reject) => {
			this.$http("getUserCourse", {
				page: page,
				pageSize: pageSize
			}).then(res => {
				if (res.code == 200) {
					resolve(res.data)
				} else {
					
				}
			})
		})
	}
	jump(item) {
		console.log(item)
		let realPrice = (Number(item.realPrice) / 100)
		let originalPrice = (Number(item.originalPrice) / 100)

		//跳转到小程序的详情页
		this.$navigateTo({
			url: `/pages/course-detail/course-detail?realPrice=${realPrice}&originalPrice=${originalPrice}&infoUrl=${item.infoUrl}&courseId=${item.id}&serviceWechat=${item.serviceWechat}&courseName=${item.courseName}&isFirst=1`
		});
	
	}
}